const SERVICES = [
  {text: 'Servicio 1', value: 1},
  {text: 'Servicio 2', value: 2},
  {text: 'Servicio 3', value: 3},
  {text: 'Servicio 4', value: 4},
  {text: 'Servicio 5', value: 5},
]

const CECOS = [
  {text: 'Ceco 1', value: 1},
  {text: 'Ceco 2', value: 2},
  {text: 'Ceco 3', value: 3},
  {text: 'Ceco 4', value: 4},
  {text: 'Ceco 5', value: 5},
]

const STATUS = [
  {text: 'Food', value: 2},
  {text: 'Sitio', value: 3},
  {text: 'Lista para integrar', value: 4},
]

const DATA = [
  {
    id: 1,
    fecha_minuta: '111111',
    fecha_tope: '111111',
    estatus: '111111',
    ceco: '111111',
    ceco_lider: '111111',
    regimen: '111111',
    servicio: '111111',
    costo_bandeja_resultante: '111111',
    costo_bandeja_target: '111111',
    zona: '111111',
    segmento: '111111',
    cumplimiento_contractual: '111111',
    cumplimiento_proceso: '111111',
    frecuencia_contractual: '111111',
    visualizar: '111111',
  },
  {
    id: 2,
    fecha_minuta: '2222222',
    fecha_tope: '2222222',
    estatus: '2222222',
    ceco: '2222222',
    ceco_lider: '2222222',
    regimen: '2222222',
    servicio: '2222222',
    costo_bandeja_resultante: '2222222',
    costo_bandeja_target: '2222222',
    zona: '2222222',
    segmento: '2222222',
    cumplimiento_contractual: '2222222',
    cumplimiento_proceso: '2222222',
    frecuencia_contractual: '2222222',
    visualizar: '2222222',
  },
  {
    id: 3,
    fecha_minuta: '333333333',
    fecha_tope: '333333333',
    estatus: '333333333',
    ceco: '333333333',
    ceco_lider: '333333333',
    regimen: '333333333',
    servicio: '333333333',
    costo_bandeja_resultante: '333333333',
    costo_bandeja_target: '333333333',
    zona: '333333333',
    segmento: '333333333',
    cumplimiento_contractual: '333333333',
    cumplimiento_proceso: '333333333',
    frecuencia_contractual: '333333333',
    visualizar: '333333333',
  },
]

const PERCENTAGES = [
    {text: '10%', value: 1},
    {text: '20%', value: 2},
    {text: '30%', value: 3},
    {text: '40%', value: 4},
    {text: '50%', value: 5},
    {text: '60%', value: 6},
    {text: '70%', value: 7},
    {text: '80%', value: 8},
    {text: '90%', value: 9},
    {text: '100%', value: 10},
]

const MONTHS = [
    {text: 'Enero', value: 1},
    {text: 'Febrero', value: 2},
    {text: 'Marzo', value: 3},
    {text: 'Abril', value: 4},
    {text: 'Mayo', value: 5},
    {text: 'Junio', value: 6},
    {text: 'Julio', value: 7},
    {text: 'Agosto', value: 8},
    {text: 'Septiembre', value: 9},
    {text: 'Octubre', value: 10},
    {text: 'Noviembre', value: 11},
    {text: 'Diciembre', value: 12},
]

export {CECOS, DATA, MONTHS, PERCENTAGES, SERVICES, STATUS }
